import React, { useCallback, useRef } from 'react'

import Icon from '../Icon/Icon'
import { closeEvent } from './ModalEvents'

const ModalHeader = ({ title, cancel = true, back = true }) => {
  const header = useRef()

  const handleClose = useCallback(() => closeEvent(header.current, false), [
    header
  ])

  return (
    <div ref={header} className='modal-header'>
      <div className='-container'>
        {back && (
          <div className='-button' onClick={handleClose}>
            <Icon size={20} icon='BackIcon' />
          </div>
        )}
        <div className='-title text-title'>{title}</div>
        {cancel && (
          <div className='-button' onClick={handleClose}>
            <Icon size={20} icon='CloseIcon' />
          </div>
        )}
      </div>
    </div>
  )
}

export default ModalHeader
